export default "__VITE_ASSET___q90UIUL__"